import React, { useMemo } from 'react';
import Charts from 'echarts-for-react';
import styles from '../styles.less';
import { CHART_COLORS, TYPE_LABEL } from '../staticData';

/** 模型错误数 TOP5（按错误数倒序取前 5） */
const ModelErrorChart = ({ list }) => {
  const option = useMemo(() => {
    const top5 = [...(list || [])]
      .sort((a, b) => Number(b.total || 0) - Number(a.total || 0))
      .slice(0, 5);
    return {
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      grid: { left: 0, right: 12, top: 28, bottom: 8, containLabel: true },
      xAxis: {
        type: 'category',
        data: top5.map((item) =>
          [
            item.modelName,
            TYPE_LABEL[item.classification] || item.classification,
          ]
            .filter(Boolean)
            .join('-'),
        ),
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { color: '#6b7280', fontSize: 12, rotate: 30 },
      },
      yAxis: {
        type: 'value',
        min: 0,
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { lineStyle: { color: '#eef1f5', type: 'dashed' } },
        axisLabel: { color: '#9ca3af', fontSize: 12 },
      },
      series: [
        {
          type: 'bar',
          barWidth: 30,
          itemStyle: { color: CHART_COLORS.error },
          label: {
            show: true,
            position: 'top',
            color: '#6b7280',
            fontSize: 12,
          },
          data: top5.map((item) => Number(item.total || 0)),
        },
      ],
    };
  }, [list]);

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>
          <svg
            className={styles.cardTitleIcon}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M1 12l4-4 3 2 6-6"
              stroke="#d98b8b"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 4h4v4"
              stroke="#d98b8b"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          模型错误数TOP5
        </span>
        <span className={styles.cardTag}>模型</span>
      </div>
      <Charts notMerge option={option} style={{ height: 260 }} />
    </div>
  );
};

export default ModelErrorChart;
